<template>
  <div class="hornor-buy-guide">
    <div class="wrapper">
      <div class="enquiries">
        <button @click="getUserAuth">马上查询我的礼包价值</button>
      </div>
      <div class="desc">还有机会成为内蒙古移动黑卡plus会员，尽享会员十大权益，抢95折超市现金券、8折大牌白酒、2折品牌耳机音箱、3折热门视频会员。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hornoBuyGuide',
  created () {
  },
  methods: {

    /**
     * 获取用户参加信用购权限
     */
    async getUserAuth () {
      this.$toast.loading('正在校验资格请稍后...')
      const res = await this.$axios.get('api/business/cpe')
      if (res.status === 200) {
        this.$toast.clear()
        const { code } = res.data
        if (code === 0) {
          await this.getUserCompetency()
        } else if (code === -1) {
          this.$toast.clear()
        } else {
          this.$toast.clear()
          this.$router.push({ name: 'hornorBuyGuideNotEligible' })
        }
      }
    },
    /**
     * 判断用户是否参加过
     */
    async getUserCompetency () {
      const res = await this.$axios.get('api/business/cre')
      if (res.status === 200) {
        this.$toast.clear()
        const { code } = res.data
        if (code === 0) {
          await this.getUserRecommend()
        } else if (code === -1) {
          this.$toast.clear()
        } else if (code === 8105) {
          this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
        } else {
          this.$toast.clear()
          this.$router.push({ name: 'hornorBuyGuideNotEligible' })
        }
      }
    },

    /**
     * 检测用户是否有推荐套餐 或者推荐开通会员
     */
    async getUserRecommend () {
      const res = await this.$axios.get('api/business/mr')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          const info = data.top_member
          if (info.member) {
            this.$router.push({ name: 'hornorBuyGuideOpen' })
          } else if (info.package) {
            this.$router.push({ name: 'hornorBuyGuideShiftUp' })
          } else if (!info.member && !info.package) {
            this.$router.push({ name: 'hornorBuyGuideNormal' })
          }
          // else {
          //   this.$router.push({ name: 'hornorBuyGuiteEnquiries' })
          // }
        } else if (code === -1) {

        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hornor-buy-guide {
  width: 100%;
  min-height: 13.34rem;
  background: url("../../assets/img/hornor-buy/hornor-banner.png") top no-repeat
    #e62717;
  background-size: 100% 9.84rem;
  padding-bottom: 0.74rem;
  .wrapper {
    padding-top: 9.27rem;
    .desc {
      font-size: @fz28;
      padding: 0.7rem 0.74rem 0;
      color: #ffdad7;
    }
  }
  .enquiries {
    width: 5.16rem;
    height: 1.14rem;
    margin: 0 auto;
    background: linear-gradient(
      180deg,
      rgba(255, 245, 207, 1) 0%,
      rgba(254, 231, 162, 1) 100%
    );
    // box-shadow: 0px 0.14rem 0.09rem 0px rgba(0, 0, 0, 0.5);
    color: #e62717;
    font-size: @fz28;
    border-radius: 30px;
    button {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
